import { translations } from "@/shared/localization/translations";



import EnterDeliveryAddressForm from "@/components/pay/EnterDeliveryAddressForm.vue";



import { VueContentPopover } from "@/app/popover/VueContentPopover";


export class EnterDeliveryAddressContentPopover extends VueContentPopover {
    constructor(isInOperatorApp: boolean, onUpdateDeliveryAddress?: () => void) {
        super({ popoverClass: "enter-delivery-address", title: translations.deliveryAddress.enterDeliveryAddress, fullscreen: false });

        this.initComponent(
            EnterDeliveryAddressForm,
            {
                hide: () => {
                    this.hide();
                },
                isInOperatorApp: isInOperatorApp,
            },
            true
        );
    }


}